/**
 * Arduino Custom Collection
 */

(() => {
    function init() {
        const collectionDesc = document.querySelector('.ino-collection__desc-wrap');
        
        if(!collectionDesc) {
            return;
        }

        const readMore = collectionDesc.querySelectorAll('.ino-collection__read-more');

        for(const btn of readMore) {
            btn.addEventListener('click', (event) => {
                const descriptions = collectionDesc.querySelectorAll('.ino-collection__desc');
                for(const desc of descriptions) {
                    desc.classList.toggle('ino-collection__desc--short');
                }

                // swap label on the button
                const label = event.target.dataset.readLessLabel;
                event.target.dataset.readLessLabel = event.target.innerText;
                event.target.innerText = label;
            });
        }
    }

    window.addEventListener('load', init);
})();